import { border, color, flexbox, layout, position, space, typography, } from 'styled-system';
import styled, { css } from '@marvelapp/styled';
import { cursor, fontVariantNumeric, hoverBoxShadow, textDecoration, textShadow, textTransform, transitionDuration, userSelect, whiteSpace, wordBreak, } from '../customProperties';
export const TextElement = styled.p `
  ${border};
  ${color};
  ${cursor};
  ${flexbox};
  ${fontVariantNumeric};
  ${layout};
  ${position};
  ${space};
  ${textDecoration};
  ${textShadow};
  ${textTransform};
  ${transitionDuration};
  ${typography};
  ${userSelect};
  ${whiteSpace};
  ${wordBreak};

  &:hover {
    ${hoverBoxShadow};
  }

  ${(props) => props.truncated &&
    css `
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `};

  ${(props) => props.truncatedTwo &&
    css `
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    `};

  ${(props) => props.wrap &&
    css `
      word-break: break-word;
    `};
`;
